export { ImagesCarouselModule } from './images-carousel.module';
